import EnterCode from './EnterCode.jsx';

export default EnterCode;